import { PageFooterLinkTypes } from "@amzn/squad-front-end-shared-react-components/dist/new-roster-design/components/pagefooter/PageFooterLinkTypes";
import {
  PageFooterItemsDto,
  LinkDto,
} from "@amzn/squad-front-end-shared-react-components/dist/new-roster-design/components/pagefooter/PageFooterItems.dto";

export const buildItems = (onFeedbackClick: () => void): LinkDto[] => [
  {
    id: "reportBug",
    displayName: "Report a bug",
    type: PageFooterLinkTypes.URL,
    actionValue:
      "https://t.corp.amazon.com/create/templates/1212803f-8c80-49ce-b2cf-5515365e64ba",
  },
  {
    id: "requestFeature",
    displayName: "Request a feature",
    type: PageFooterLinkTypes.URL,
    actionValue: "https://tiny.amazon.com/1c7e9xv64",
  },
  {
    id: "provideFeedback",
    displayName: "Provide feedback",
    type: PageFooterLinkTypes.FEEDBACK,
    actionValue: onFeedbackClick,
  },
];

export const buildLinkItems = (
  onFeedbackClick: () => void
): PageFooterItemsDto => ({
  links: buildItems(onFeedbackClick),
});
